<h2 mat-dialog-title class="public-link-dialog__title high-contrast-text">
  <ng-container
    *ngIf="dialogData.titleKey || dialogData.title; else titleFromQuestion"
  >
    {{
      dialogData.titleKey
        ? (dialogData.titleKey | translate)
        : dialogData.title
    }}
  </ng-container>
  <ng-template #titleFromQuestion>
    {{ dialogData.questionKey | translate }}
  </ng-template>
</h2>

<mat-dialog-content class="public-link-dialog__content">
  <a
    mat-stroked-button
    class="public-link-dialog__url-button"
    [href]="questionUrl.url"
    target="_blank"
    rel="noopener"
  >
    <span class="public-link-dialog__url-inner">
      <mat-icon class="public-link-dialog__url-icon shrink-0">open_in_browser</mat-icon>
      <span class="public-link-dialog__url-text">{{ questionUrl.url }}</span>
    </span>
  </a>

  <div class="public-link-dialog__qr">
    <qr-code
      [value]="questionUrl.url"
      size="300"
      errorCorrectionLevel="M"
    ></qr-code>
  </div>
</mat-dialog-content>

<mat-dialog-actions class="public-link-dialog__actions">
  <button mat-button mat-dialog-close type="button" class="secondary-button">
    {{
      dialogData.btnCancelLabelKey
        ? (dialogData.btnCancelLabelKey | translate)
        : dialogData.btnCancelLabel
    }}
  </button>

  <button
    mat-button
    type="button"
    [mat-dialog-close]="true"
    cdkFocusInitial
    class="primary-button"
  >
    {{
      dialogData.btnOkLabelKey
        ? (dialogData.btnOkLabelKey | translate)
        : dialogData.btnOkLabel
    }}
  </button>
</mat-dialog-actions>
